export default "__VITE_ASSET__1c155036__"